import Pdf from './generators/Pdf'
import Csv from './generators/Csv'

function isArray (value) {
  return value && typeof value === 'object' && value.constructor === Array
}

function isObject (value) {
  return value && typeof value === 'object' && value.constructor === Object
}

const PDF_TYPE = 1
const CSV_TYPE = 2

export default class Printer {
  constructor (schema, type = PDF_TYPE) {
    switch (type) {
    case PDF_TYPE:
        this.generator = new Pdf(schema)
        break
    case CSV_TYPE:
        this.generator = new Csv(schema)
        break
    default:
        throw new Error('Unknown generator type')
    }
  }

  export (data = null) {
    if (data) {
      this.load(data)
    }
    this.generator.save()
  }

  load (data) {
    if (isArray(data)) {
      this.loadAll(data)
    } else if (isObject(data)) {
      this.loadSingle(data)
    } else {
      throw new TypeError()
    }
  }

  loadSingle (record) {
    this.generator.loadRecord(record)
  }

  loadAll (records) {
    this.generator.loadMultipleRecords(records)
  }

  static get PDF_TYPE () {
    return 1
  }

  static get CSV_TYPE () {
    return 2
  }
}
